export default {
  already_confirmed: {
    pt: 'Este filme já foi enviado e está confirmado para o concurso!',
    en: 'This film has already been sent and it\'s confirmed for the contest!'
  },
  not_confirmed: {
    pt: 'Este filme não está confirmado por pendência de pagamento.',
    en: 'This film is not confirmed due to pending payment.'
  },
  rules_required: {
    pt: 'Campo obrigatório.',
    en: 'Required field.'
  },
  rules_video: {
    pt: 'Preencha um URL válido do Youtube ou Vimeo.',
    en: 'Fill in a valid Youtube or Vimeo url.'
  },
  new_video_duplicate: {
    pt: 'O URL do vídeo que você preenchou já foi adicionado anteriormente',
    en: 'The URL of the video you have entered has already been added'
  },
  video_url: {
    pt: 'URL do filme',
    en: 'Film URL'
  },
  video_title: {
    pt: 'Título do filme',
    en: 'Film title'
  },
  film_category: {
    pt: 'Categoria do filme',
    en: 'Film category'
  },
  wedding_film: {
    pt: 'Filme de casamento',
    en: 'Wedding film'
  },
  pre_wedding_film: {
    pt: 'Filme de pré-casamento',
    en: 'Couple film'
  },
  family_film: {
    pt: 'Filme de família',
    en: 'Family film'
  },
  film_cover: {
    pt: 'Capa do filme',
    en: 'Film cover'
  },
  upload_film_cover_note: {
    pt: 'Imagem deve ser .jpg e 1280x720',
    en: 'Image must be .jpg and 1280x720'
  },
  film_poster: {
    pt: 'Poster do filme',
    en: 'Film poster'
  },
  upload_film_poster_note: {
    pt: 'Imagem deve ser .jpg e 720x1280',
    en: 'Image must be .jpg and 720x1280'
  },
  confirm: {
    pt: 'Confirmar',
    en: 'Confirm'
  },
  videos_alert: {
    pt: 'Preencha o campo com um URL de vídeo válido do Youtube ou Vimeo.',
    en: 'Fill in the field with a valid Youtube or Vimeo video URL.'
  },
  remove_video: {
    pt: 'Remover vídeo',
    en: 'Remove video'
  }
}
